import {Box, Typography} from "@mui/material";

const SimpleTabPanel = ({value, index, children}) => {

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
        >
            {value === index && (
                <div sx={{ pt: 2 }}>
                    {children}
                </div>
            )}
        </div>
    );
}

export default SimpleTabPanel